import { get } from 'lodash-es'

export const toExperimentMap = (data: Json): TExperimentMap => {
    const experiments: TExperiment[] = get(data, '_embedded.self', []).map((experiment: Json) => ({
        experimentName: get(experiment, 'experimentName'),
        segment: get(experiment, 'segment'),
    }))

    return Object.fromEntries(experiments.map((experiment) => [experiment.experimentName, experiment.segment]))
}
